export const Image: React.FC<JSX.IntrinsicElements['img']> = (props) => {
  const { src, alt, className } = props;
  return <img src={src} alt={alt} className={className} />;
};
